module.exports = __webpack_public_path__ + "files/682228b3139646d1645873e60ad44129.png";